import RemoveProductCodeModal from './RemoveProductCodeModal';

export default RemoveProductCodeModal;
